import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'semantic-ui-react'

const Name = ({
  name,
}) => (
  <Card.Header className="product-name">
    {name}
  </Card.Header>
)

Name.propTypes = {
  name: PropTypes.string,
}
Name.defaultProps = {
  name: '',
}

export default Name



// WEBPACK FOOTER //
// ./src/cms/components/productCard/Name.js